import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'O MenoEase substitui a consulta médica?',
    answer: 'Não. O MenoEase é uma ferramenta de apoio e acompanhamento. Ele ajuda você a monitorar seus sintomas e gerar relatórios detalhados para compartilhar com seu médico, tornando suas consultas mais produtivas. Sempre consulte um profissional de saúde.',
  },
  {
    question: 'Meus dados estão seguros?',
    answer: 'Sim! A privacidade é nossa prioridade. Seus dados são criptografados e armazenados de forma segura. Não compartilhamos suas informações pessoais com terceiros. Você tem controle total sobre seus dados.',
  },
  {
    question: 'Posso usar o app gratuitamente?',
    answer: 'Sim! Ao se cadastrar, você ganha 7 dias de acesso completo a todas as funcionalidades do MenoEase, incluindo chat com IA, relatórios avançados e insights personalizados. Após esse período, você pode continuar usando o app gratuitamente com funcionalidades básicas (checklist diário, monitoramento de ciclo, diário de saúde e rastreador de água) ou assinar um dos nossos planos premium para manter o acesso completo.',
  },
  {
    question: 'Como funciona o chat com IA?',
    answer: 'Nosso chat com IA é treinado especificamente sobre menopausa e saúde feminina. Você pode fazer perguntas a qualquer hora do dia ou da noite e receber respostas baseadas em evidências científicas. Esta funcionalidade está disponível nos planos premium.',
  },
  {
    question: 'Posso cancelar minha assinatura?',
    answer: 'Sim, você pode cancelar sua assinatura a qualquer momento, sem taxas de cancelamento. Além disso, oferecemos 7 dias de garantia de reembolso em todos os planos pagos.',
  },
  {
    question: 'O app funciona em qual plataforma?',
    answer: 'O MenoEase está disponível como aplicativo web (acessível pelo navegador) e também como app mobile para iOS e Android através do Expo Go. Você pode acessar de qualquer dispositivo.',
  },
  {
    question: 'Preciso estar na menopausa para usar?',
    answer: 'Não necessariamente. O MenoEase é ideal para mulheres em qualquer fase da transição hormonal: perimenopausa, menopausa ou pós-menopausa. Quanto mais cedo você começar a monitorar, melhor.',
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #fafaf9 0%, #FFF5F8 50%, #fafaf9 100%)' }}
    >
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FAADC7] to-transparent" />

      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold text-[#B54182] uppercase tracking-widest mb-4 block">
            Perguntas Frequentes
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-stone-900 mb-6"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            Tire suas{' '}
            <span className="text-[#B54182]">dúvidas</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-2xl border border-stone-100 shadow-sm px-6 overflow-hidden data-[state=open]:shadow-md data-[state=open]:border-[#FAADC7] transition-all duration-300"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-base font-semibold text-stone-800 hover:text-[#B54182] py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-stone-500 text-sm leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
